import { useCallback, useMemo, useState } from 'react'

import { iconList } from 'core-components/constants/icons'
import { Accordion } from 'core-components/library/accordion'
import { Input } from 'core-components/library/inputs'

import { Icon } from './Icon'
import { IIconData } from './models/IIconData'

import styles from './IconsList.module.scss'

interface IIconList {
  onChange?: (icon: string) => void
}

export const IconsList = ({ onChange }: IIconList) => {
  const [search, setSearch] = useState<string>('')

  const groupIcons = useCallback((list: IIconData[]) => {
    return list.reduce((groups, item) => {
      const group = groups[item.group] || []
      group.push(item)
      groups[item.group] = group
      return groups
    }, {})
  }, [])

  const icons: [][] = useMemo(() => {
    return Object.values(groupIcons(iconList))
  }, [groupIcons])

  return (
    <div>
      <div>Icons</div>
      <div className={styles.stickySearch}>
        <Input
          label={'Search'}
          margin={'md'}
          value={search}
          __testId={'icon-list__search-input'}
          onChange={(value) => {
            setSearch(value.trim())
          }}
        />
      </div>

      {icons.map((item: IIconData[]) => {
        return (
          <Accordion
            key={`group-${item[0].group || 'other'}`}
            className={styles.accordion}
            title={item[0].group || 'Other'}
            opened
            margin={'md'}
          >
            <div className={styles.grid}>
              {item.map((icon) => {
                const show = icon.id.includes(search) || icon.alias.includes(search)

                return (
                  <Icon
                    overlayVisible={false}
                    key={icon.id}
                    group={icon.group}
                    className={styles.grid__item}
                    iconId={icon.id}
                    show={show}
                    onClick={onChange}
                  />
                )
              })}
            </div>
          </Accordion>
        )
      })}
    </div>
  )
}
